export default __webpack_public_path__ + "static/media/tempreture-weather.919b88b9.png";